import { useRef, useState } from "react";
import { Box, Tooltip } from "@mui/material";

const DEFAULT_SLOT_PROPS = {
  tooltip: {
    sx: {
      bgcolor: "#000000",
      color: "#FFFFFF",
      fontFamily: "Lato, sans-serif",
      fontSize: 12,
      fontWeight: 400,
      lineHeight: "18px",
      px: 1.5,
      py: 1,
      maxWidth: 320,
      wordBreak: "break-word",
      "& .MuiTooltip-arrow": { color: "#000000" },
    },
  },
};

/**
 * Tooltip on hover only when child content is visually truncated.
 */
export default function TruncationTooltip({
  title,
  children,
  checkMultiline = false,
  placement = "bottom",
  slotProps = DEFAULT_SLOT_PROPS,
}) {
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const fullTitle = String(title ?? "").trim();

  const measure = () => {
    if (!fullTitle) {
      setOpen(false);
      return;
    }
    const root = rootRef.current;
    if (!root) {
      setOpen(false);
      return;
    }
    const target =
      root.querySelector("[data-truncation-measure]") ||
      root.querySelector("textarea") ||
      root.querySelector("input") ||
      root.querySelector(".MuiChip-label") ||
      root.querySelector(".MuiTypography-root") ||
      root;
    const truncated = checkMultiline
      ? target.scrollHeight > target.clientHeight + 1 || target.scrollWidth > target.clientWidth
      : target.scrollWidth > target.clientWidth;
    setOpen(truncated);
  };

  if (!fullTitle) {
    return children;
  }

  return (
    <Tooltip
      title={fullTitle}
      arrow
      placement={placement}
      open={open}
      onClose={() => setOpen(false)}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      slotProps={slotProps}
      describeChild
    >
      <Box
        ref={rootRef}
        onMouseEnter={measure}
        onMouseLeave={() => setOpen(false)}
        sx={{ minWidth: 0, maxWidth: "100%" }}
      >
        {children}
      </Box>
    </Tooltip>
  );
}
